import isNull from 'lodash/isNull'

import { entityToNameInValueLabelValue, NameCodeToLabelValue } from 'Core/utils'

import { getYearPeriod } from '../../Components/DataEntry/TableList/Table/utils/helpers'
import { Kpi, MeasureType, MetricByPeriods, TermCodeType } from '../../entities'

export const getSelectsConfig = (kpiById: Kpi.Basic | null) => {
	if (isNull(kpiById)) {
		return {}
	}

	const isUomSelectExist = kpiById.kpiUOMs.length > 1
	const isKpiSelectExist = [MeasureType.boolean, MeasureType.predefinedString].includes(
		kpiById.measureType
	)

	return {
		...(isUomSelectExist && {
			uom: {
				options: kpiById.kpiUOMs.map(NameCodeToLabelValue),
				placeholder: 'Select UOM'
			}
		}),
		...(isKpiSelectExist && {
			kpi: {
				options: kpiById.kpiValueOptions.map(entityToNameInValueLabelValue),
				placeholder: 'Select KPI'
			}
		})
	}
}

export const getAllowedEditableTerms = (termCodeType?: TermCodeType) => {
	if (!termCodeType) {
		return []
	}

	const MONTHES_AMOUNT_FOR_TWO_YEARS = 13

	const yearQuantity =
		termCodeType === TermCodeType.YEARLY ? MONTHES_AMOUNT_FOR_TWO_YEARS : undefined

	const allowedTerms = getYearPeriod(termCodeType, yearQuantity).map(
		({ extra, saveValue }) => `${extra}:${saveValue}`
	)
	return allowedTerms
}

export const getMappedMetricsByPeriod = (data: MetricByPeriods.Basic[]) =>
	data.map((item) => {
		let yearTerm: Kpi.KpiLocationMeasure | null = null
		const correctPeriods = item.measures.reduce((acc, record) => {
			if (record.term === 'YEAR') {
				yearTerm = record
				return acc
			}
			acc[record.term] = record
			return acc
		}, {} as Record<string, Kpi.KpiLocationMeasure>)

		const rest = !!yearTerm ? yearTerm : correctPeriods
		return {
			location: item.location,
			...rest
		}
	}) as Kpi.MetricTermRow[]
